module.exports = __webpack_public_path__ + "img/w3_circle_up_dark.8e8c453a.8e8c453a.png";